import { useContext, useState } from 'react';
import { AccountContext } from "../AccountContext";
import {useAsyncEffect} from "../../../hooks/UseAsyncEffect";
import {toFormattedRate} from "../../../utilities/FormatHelpers";

export default function CreateInterestTransaction() {
    const { accountId, interestService, setError } = useContext(AccountContext);
    const [amount, setAmount] = useState(0.00);
    const [direction, setDirection] = useState("Credit");
    const [description, setDescription] = useState('Manual Interest');
    const [subledgerId, setSubledgerId] = useState(undefined as string);
    const [creatingTransaction, setCreatingTransaction] = useState(false as boolean);
    const [subledgerEffectiveRates, setSubledgerEffectiveRates] = useState(undefined as any);

    useAsyncEffect(async () => {
        if(accountId) {
            const response = await interestService.getAccountEffectiveRates(accountId);
            setSubledgerEffectiveRates(response.subledgerRates);
        }
    }, [accountId])

    const onSubmitClicked = async () => {
        try {
            setCreatingTransaction(true);
            const directedAmount = direction == 'Debit' ? amount*-1 : amount;
            await interestService.createInterestTransaction(accountId, directedAmount, description, subledgerId);
            setCreatingTransaction(false);
        } catch (error) {
            setCreatingTransaction(false);
            setError({ source: 'Create Adjustment', ...error });
        }
    };

    return (
        <div className="ui card">
            <div className="custom-card-header">
                Manual Interest Transaction
            </div>
            <div className="content">
                <div className="ui form">
                    <div className="field">
                        <label>Amount</label>
                        <div className="ui labeled input">
                            <div className="ui label">
                                £
                            </div>
                            <input type="number" placeholder="Amount" min="0" step=".01" disabled={creatingTransaction} onChange={e => setAmount(parseFloat(e.target.value))} />
                        </div>
                    </div>
                    <div className="field">
                        <label>Description</label>
                        <input type="text" placeholder="Description" value={description} disabled={creatingTransaction} onChange={e => setDescription(e.target.value)} />
                    </div>
                    <div className="field">
                        <div className="ui labeled input">
                            <div className="ui label">Subledger</div>
                            <select onChange={e => setSubledgerId(e.target.value)}>
                                    <option value="">-- Select Subledger --</option>
                                {subledgerEffectiveRates && subledgerEffectiveRates.map(sl =>
                                    <option key={sl.subledgerId} value={sl.subledgerId}>{sl.rate.spendType} {toFormattedRate(sl.rate.rate)}</option>
                                )}
                            </select>
                        </div>
                    </div>

                    <div className="field">
                        <div className="ui labeled input">
                            <div className="ui label">Direction</div>
                            <select onChange={e => setDirection(e.target.value)}>
                                <option value="Credit">Credit</option>
                                <option value="Debit">Debit</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <button className={`ui primary button ${creatingTransaction && 'loading'}`} type="submit" onClick={() => onSubmitClicked()}>Submit</button>
        </div>
    );
}